import InputNumber from 'antd/lib/input-number';
export default InputNumber;